import { PageIntro } from '../components/PageIntro';
import { Seo } from '../components/Seo';
import { siteConfig } from '../config/site';

export function ContactPage() {
  return (
    <>
      <Seo title="Contact" description="Ask about home repair assistance, volunteering, or community partnership." />
      <PageIntro eyebrow="Contact" title="How can we help?">
        <p>Reach out to ask about repair assistance, volunteer opportunities, donations, or community partnerships.</p>
      </PageIntro>
      <section className="section">
        <div className="container contact-grid">
          <div>
            <p className="eyebrow">Contact details</p>
            <h2>{siteConfig.email}</h2>
            <p>Service area: [To be confirmed]</p>
            <p className="placeholder-note">Please do not send Social Security numbers, financial documents, or other sensitive information by email.</p>
          </div>
          <aside className="notice-card" aria-labelledby="form-status-heading">
            <h2 id="form-status-heading">Need repair assistance?</h2>
            <p>
              Tell us your location and a brief description of the repair by email. Program availability and eligibility requirements will be confirmed when we respond.
            </p>
          </aside>
        </div>
      </section>
    </>
  );
}
